<template>
	<div>
		<v-row dense v-if="communicatonItem">
			<v-col v-if="!$_.get(hiddenFields, 'phone', false)" cols="12" sm="6" md="6" lg="6" xl="6">
				<v-text-field
					:disabled="disabled"
					v-model="communicatonItem.phone"
					outlined
					dense
					:label="$t('phone')"
				></v-text-field>
			</v-col>
			<v-col v-if="!$_.get(hiddenFields, 'mobile', false)" cols="12" sm="6" md="6" lg="6" xl="6">
				<v-text-field
					:disabled="disabled"
					v-model="communicatonItem.mobile"
					outlined
					dense
					:label="$t('mobile')"
				></v-text-field>
			</v-col>
			<v-col v-if="!$_.get(hiddenFields, 'email', false)" cols="12" sm="6" md="6" lg="6" xl="6">
				<v-text-field
					:disabled="disabled"
					v-model="communicatonItem.email"
					outlined
					dense
					:label="$t('email')"
				></v-text-field>
			</v-col>
		</v-row>
	</div>
</template>

<script>
// globals
// locals
import i18n from './dictionary';
// models
// components

export default {
	name: `CommuncationForm`,
	components: {},
	mixins: [],
	i18n,
	props: {
		value: {
			required: true,
		},
		disabled: {
			type: Boolean,
			required: false,
		},
		hiddenFields: {
			type: Object,
			required: false,
		},
	},
	data() {
		return {};
	},
	computed: {
		communicatonItem: {
			get() {
				return this.value;
			},
			set(value) {
				this.$emit('input', value);
			},
		},
	},
	methods: {},
};
</script>
